import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BalancePill from '../BalancePill';
import AvatarDropdown from '../AvatarDropdown';

function Header({ online, player, onLogout }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const onGamesList = location.pathname === '/games';
    return (
        <header className="neon-panel scanlines px-3 py-2 sm:px-4 sm:py-2.5 relative z-30">
            <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                    <button
                        type="button"
                        onClick={() => navigate('/games')}
                        className="text-lg sm:text-xl font-black font-display text-white whitespace-nowrap hover:opacity-90 transition"
                        aria-label={t('common.goToGames', 'Games')}
                    >
                        BG<span className="text-cyber-purple glow-purple ml-1">GAMES</span>
                    </button>
                    {!onGamesList && (
                        <button
                            type="button"
                            onClick={() => navigate('/games')}
                            className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-cyber-cyan/40 text-cyber-cyan text-[11px] font-display tracking-widest hover:bg-cyber-cyan/10 hover:border-cyber-cyan/70 transition"
                        >
                            <span aria-hidden="true">←</span>
                            <span>{t('common.allGames', 'All games')}</span>
                        </button>
                    )}
                    {!onGamesList && (
                        <button
                            type="button"
                            onClick={() => navigate('/games')}
                            className="sm:hidden inline-flex items-center justify-center w-8 h-8 rounded-md border border-cyber-cyan/40 text-cyber-cyan hover:bg-cyber-cyan/10 transition"
                            aria-label={t('common.allGames', 'All games')}
                        >
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M15 18l-6-6 6-6" />
                            </svg>
                        </button>
                    )}
                    <div className="hidden md:flex items-center gap-1.5 text-[10px] text-cyber-dim tracking-widest">
                        <span className="w-1.5 h-1.5 rounded-full bg-cyber-cyan animate-pulse" />
                        {t('game.operatorsOnline', { count: online })}
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <BalancePill
                        balance={player.balance}
                        onTopUp={player.name ? () => navigate('/profile') : undefined}
                    />
                    {player.name && (
                        <AvatarDropdown
                            player={player}
                            onProfile={() => navigate('/profile')}
                            onAdmin={player.isAdmin ? () => navigate('/admin') : undefined}
                            onLogout={onLogout}
                        />
                    )}
                </div>
            </div>

            {/* Mobile-only online indicator under the bar (icon row on small screens) */}
            <div className="md:hidden mt-2 pt-2 border-t border-cyber-border/40 flex items-center gap-2 text-[10px] text-cyber-dim tracking-widest">
                <span className="w-1.5 h-1.5 rounded-full bg-cyber-cyan animate-pulse" />
                {t('game.online', { count: online })}
            </div>
        </header>
    );
}

export default Header;
